import BasicResource from '@/api/resource';

class ExternalIntegrations extends BasicResource {
    constructor () {
        super('sync-configurations');
    }
}

export default new ExternalIntegrations;
